import React, { useEffect, useState } from 'react'
import FullCalendarComp from '../../common/textfield/FullCalendar'
import moment from 'moment'
import { intialData } from './constants'
import { useGetPractScheduleByDate } from '../../../hooks/ReactQueryHooks/useGetPractScheduleByDate'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { getDaysBetweenDates } from '../../common/functions'
import { ViewScheduleDayModal } from './ViewScheduleDayModal'
import { Button } from '../../common/Button'
import { decryptData } from '../../EncryptDecrypt'
import {getScheduleSlots} from "../../api/Schedule"

const parseCalendarDate = (date) => moment(date, ["YYYY-MM-DD", "MM/DD/YYYY"], true);

const CalendarView = () => {
    const navigate = useNavigate();
    const [scheduleDaysCategory, setScheduleDaysCategory] = useState(JSON.parse(JSON.stringify(intialData)));
    const [showShedule, setShowShedule] = useState(false);
    const [recentSchedule, setRecentSchedule] = useState(false);
    const [highlightedDate, setHighlightedDate] = useState(new Set());
    const [currentDate, setCurrentDate] = useState(null)
    const [eventsList, setEventsList] = useState([]);
    const [scheduledDates, setScheduledDates] = useState(new Set());
    const [selectedDate, setSelectedDate] = useState(null);
    const [unprocessedSchedule, setUnprocessedSchedule] = useState([]);
    const [allSchedules, setAllSchedules] = useState(null);
    const [colourOfSchedule, setColourOfSchedule] = useState({});
    const location = useLocation();
    const logedInUserData = useSelector((state) => state?.auth?.user);
    const userID = location?.state?.data ? location?.state?.data?.id : logedInUserData?.["custom:unique_id"];


    useGetPractScheduleByDate({
        onSuccess: (data) => {
            data?.data && currentRecentSchedule(data?.data)
        },
        practId: userID,
        isGetAll: true,
    })

    const setDateAndSelectedSchedule = (info) => {
        let date = info.startStr; // YYYY-MM-DD format
        let id = date
        
        let event = info.view.calendar.getEventById(id);
        if (event?.extendedProps?.scheduleId) {
            // if there is an event on that day, that means there is a schedule, so you can edit the schedule on this date
            location.date = `${date}`;
            setSelectedDate(`${date}`);
        }
        else {
            location.date = null;
            setSelectedDate(null);
        }
    }

    const currentRecentSchedule = (data) => {
        setRecentSchedule(true)
        setAllSchedules(data);
        const colors = ['rgb(0, 93, 168)', 'rgb(0, 71, 171)', 'rgb(0, 0, 139)', 'rgb(111, 143, 175)', 'rgb(25, 25, 112)', '	rgb(96, 130, 182)', 'rgb(100, 149, 237)'];
        let scheduleColors = {};
        const unprocessedSchedules = [];
        const categoryUpdate = scheduleDaysCategory;
        const copyScheduledDates = scheduledDates;
        data?.forEach((schedule) => {       
            scheduleColors[schedule.id] = colors[Math.floor(Math.random() * (colors.length))];
            unprocessedSchedules.push(schedule.id);
            schedule?.serviceCategory?.map((categoryData) => {
                const date = moment(categoryData?.date).format("YYYY-MM-DD");
                copyScheduledDates.add(date);
                const day = moment(categoryData?.date).format("dddd")
                categoryUpdate?.[day]?.push(categoryData?.id)
                return categoryData
            }
        )})
        setColourOfSchedule(scheduleColors)
        setScheduledDates(copyScheduledDates)
        setScheduleDaysCategory(categoryUpdate)
        setUnprocessedSchedule(unprocessedSchedules);
        highlightDates(data, unprocessedSchedules);
        
    }

    useEffect(() => {
        if(allSchedules){
            highlightDates(allSchedules);
        }
    },[currentDate, allSchedules])


    const highlightDates = async (data, unprocessedSchedules = [] ) =>{
        if(highlightedDate && highlightedDate?.has(currentDate?.start)) {
            return;
        }
        if(unprocessedSchedules.length === 0) {
            unprocessedSchedules = unprocessedSchedule
        }
        highlightedDate.add(currentDate?.start);
        const unavailableColor = '#f0f0f0';
        const tempSchedule= []
        const copyScheduledDates = scheduledDates;
        const promises = data?.map(async (schedule) => {
            let scheduleStart = moment(schedule?.planningHorizon?.start);
            const rangeStart = moment(currentDate?.start, "YYYY-MM-DD");
            const rangeEnd = moment(currentDate?.end, "YYYY-MM-DD");
            const isInRange = scheduleStart.isBetween(rangeStart, rangeEnd, 'day', '[]');
            const isUnprocessed = unprocessedSchedules.includes(schedule.id);

            if (isInRange && isUnprocessed) {
                tempSchedule.push(schedule.id);

                const res = await getScheduleSlots(schedule.id, "busy-reserved");
                res.data?.forEach((slot) => {
                    const slotDate = moment(slot?.start).format("YYYY-MM-DD");
                    copyScheduledDates.add(slotDate);
                });
            }
        });

        await Promise.all(promises);
        setUnprocessedSchedule(unprocessedSchedules.filter((item) => !tempSchedule.includes(item)));
        const tempEventsList = data?.map((schedule) => getDaysBetweenDates(moment(schedule?.planningHorizon?.start).format("YYYY-MM-DD"), moment(schedule?.planningHorizon?.end).format("YYYY-MM-DD"))
            .map((appointmentData) => {
                const appointmentDate = parseCalendarDate(appointmentData).format("YYYY-MM-DD");
                return {
                    id: appointmentDate,
                    scheduleId: schedule.id,
                    title: appointmentData,
                    start: appointmentDate,
                    end: appointmentDate,
                    backgroundColor: copyScheduledDates.has(appointmentDate)? colourOfSchedule[schedule.id] : unavailableColor,
                    date: appointmentDate,
                    ...(copyScheduledDates.has(appointmentDate) ? {} : { textColor: "#888888" })
                };
            })).flat()
        setEventsList(tempEventsList)
        setScheduledDates(copyScheduledDates);
    }

    return (
        <section className="common-listing">
            {showShedule ? <ViewScheduleDayModal modalShow={showShedule} handleShow={() => setShowShedule(false)} userID={userID} /> : null}

            <div className="heading-wrap h-change mb-4">
                <h1>{location?.state?.data
                    ? <>Schedule of <span style={{ textTransform: 'capitalize' }}>{decryptData(location?.state?.data?.name?.[0]?.text)}</span></>
                    : "My Schedule"}</h1>
                <div className="right-wrap">
                    {recentSchedule && selectedDate
                        ? <Button disabled={selectedDate == null}  onClick={() => navigate("/app/edit-schedule", {state: { ...location?.state, date: location?.date }})} className="custom-btn" style={{ width: 'auto' }}>Edit</Button>
                        : null}
                    <Button onClick={() => navigate("/app/create-schedule", { state: location?.state })} className="custom-btn" style={{ width: 'auto' }}>Create</Button>
                </div>
            </div>
            <FullCalendarComp eventsList={eventsList}
                selectable={true}
                eventDisplay="block"
                eventClick={(e) => setShowShedule(e?.event?.id)}
                select={(e) => setDateAndSelectedSchedule(e)}
                setCurrentDate={setCurrentDate}
            />
        </section>
    )
}

export default CalendarView
